import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';
export default (props => {
  return React.createElement(SvgIcon, null, React.createElement("path", {
    d: "M4 3V5L20 5V3L4 3Z",
    fill: "black"
  }), React.createElement("path", {
    d: "M9 12C9 13.6569 10.3431 15 12 15V15C13.6569 15 15 13.6569 15 12V12C15 10.3431 13.6569 9 12 9V9C10.3431 9 9 10.3431 9 12V12Z",
    fill: "black"
  }));
});